import { useNavigate } from "react-router-dom";
import HallImgCarousel from "./HallImgCarousel";
import "./hallCard.scss";
import { addComma } from "@src/utils";

type Props = {
  type: "default" | "preview";
  hallData: any;
  compareClassName: any;
  partnerProfileId?: string;
  partnerId:number
};

const HallCard = ({ type, hallData, compareClassName, partnerProfileId,partnerId}: Props) => {
  const navigate = useNavigate();
  return (
    <div className="hallcard-wrap">
      <HallImgCarousel type="hall" width={window.innerWidth - 40} height={217} imgs={hallData.images} />
      <div 
        className="card-info-wrap" 
        onClick={()=>{
          type === "default" 
            ? navigate(`detail/${hallData.uuid}`,{state:partnerId}): navigate(`/weddinghall/${partnerProfileId}/detail-preview/${hallData.id}`)
            }}>
          <p className={`hallname bold ${compareClassName?.name}`}>{hallData.name}</p>
          <div className="hallcard-info">
            <p>
              <span>대관료</span> 
              <span>{addComma(hallData.regularPrice.rentalFee)}원</span>
            </p>
            <p>
              <span>식대</span>
              <span>{addComma(hallData.regularPrice.adultDrinkFee)}원</span>
            </p>
            <p>
              <span>예식간격</span>
              <span>{hallData.weddingGapMinutes.join("분, ")}분</span>
            </p>
            <p>
              <span>추천인원</span>
              <span>{hallData.suggestPersonnel}명</span>
            </p>
          </div>
          <button className="btn btn-full btn-outline-gray200">더보기</button>
      </div>
    </div>
  );
};

export default HallCard;
